import {
    BriefcaseBusiness,
    Building2,
    Calendar,
    CalendarDays,
    ClipboardList,
    Clock,
    FileText,
    Hash,
    HeartPulse,
    Home,
    LocateFixed,
    MapPin,
    Phone,
    Repeat,
    ShieldCheck,
    Timer,
    UserCog,
    UserRound,
    UsersRound,
} from 'lucide-react';
import { type ReactNode } from 'react';

import { getDataSourceDisplayName } from '@apps/web/lib/data_source_utils';
import { withTemplateVariableAliases } from '@apps/web/lib/template_variables';

const TEMPLATE_VARIABLE_ICON_CLASS = 'h-3.5 w-3.5 shrink-0';

export const TEMPLATE_VARIABLE_ICONS = {
    assistant_name: (
        <Phone aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    care_coordinator: (
        <UserCog aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    care_plan_summary: (
        <FileText aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    caregiver_distance: (
        <LocateFixed
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    caregiver_first_name: (
        <UserRound
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    caregiver_last_name: (
        <UserRound
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    caregiver_name: (
        <UserRound
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    clean_record_month: (
        <Calendar aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    client_groups: (
        <UsersRound
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    client_address: (
        <Home aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    client_city: (
        <MapPin aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    client_state: (
        <MapPin aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    client_first_name: (
        <HeartPulse
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    client_initials: (
        <HeartPulse
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    client_first_initial: (
        <HeartPulse
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    client_last_initial: (
        <HeartPulse
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    client_last_name: (
        <HeartPulse
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    client_name: (
        <HeartPulse
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    client_reference_term: (
        <HeartPulse
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    client_street_name: (
        <Home aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    client_zip_code: (
        <Hash aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    display_name: (
        <UserRound
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    ehr: (
        <FileText aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    evv_text: (
        <ShieldCheck
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    group_acceptance_requirement: (
        <ClipboardList
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    group_number: (
        <Hash aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    location_text: (
        <MapPin aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    milestone_duration: (
        <Timer aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    organization_name: (
        <Building2
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    patient_address: (
        <Home aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    patient_city: (
        <MapPin aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    patient_state: (
        <MapPin aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    patient_first_name: (
        <HeartPulse
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    patient_last_name: (
        <HeartPulse
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    patient_name: (
        <HeartPulse
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    patient_street_name: (
        <Home aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    patient_text: (
        <HeartPulse
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    patient_zip_code: (
        <Hash aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    phoebe_intro: (
        <Phone aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    previous_visits: (
        <FileText aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    role_required: (
        <BriefcaseBusiness
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    schedule_summary: (
        <CalendarDays
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    shift_count: (
        <ClipboardList
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    shift_count_number: (
        <ClipboardList
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    shift_date: (
        <Calendar aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    shift_day_of_week: (
        <CalendarDays
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    shift_duration: (
        <Timer aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    shift_frequency: (
        <Repeat aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    shift_groups: (
        <UsersRound
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    shift_list: (
        <ClipboardList
            aria-hidden="true"
            className={TEMPLATE_VARIABLE_ICON_CLASS}
        />
    ),
    shift_start_time: (
        <Clock aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    shift_end_time: (
        <Clock aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    start_date: (
        <Calendar aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
    time_and_attendance_pin: (
        <Hash aria-hidden="true" className={TEMPLATE_VARIABLE_ICON_CLASS} />
    ),
} satisfies Readonly<Record<string, ReactNode>>;

export const DEFAULT_TEMPLATE_VARIABLE_SAMPLE_VALUES: Readonly<
    Record<string, string>
> = {
    assistant_name: 'Phoebe',
    care_coordinator: 'Maya Lee',
    care_plan_summary: 'Light housekeeping and meal prep.',
    caregiver_distance: '3.2 miles from you',
    caregiver_first_name: 'Sarah',
    caregiver_last_name: 'Johnson',
    caregiver_name: 'Sarah Johnson',
    clean_record_month: 'June',
    client_address: '123 Main St, Apt 2B, Brooklyn, NY 11201',
    client_city: 'Brooklyn',
    client_first_name: 'Jane',
    client_initials: 'J.S.',
    client_first_initial: 'J.',
    client_last_initial: 'S.',
    client_groups:
        'Jane Smith in Brooklyn:\n1. Wednesday, July 1st, 9:00 AM-5:00 PM',
    client_last_name: 'Smith',
    client_reference_term: 'client',
    client_state: 'NY',
    client_street_name: 'Main St',
    client_zip_code: '11201',
    display_name: 'Phoebe',
    ehr: 'WellSky',
    evv_text: 'Please complete EVV before clocking out.',
    group_acceptance_requirement: 'Please accept all shifts in this group.',
    group_number: '1',
    location_text: ' in Brooklyn',
    monthly_clients_visited: '4 clients',
    monthly_hours_worked: '87.5 hours',
    monthly_shifts_worked: '12 shifts',
    milestone_duration: 'one month',
    organization_name: 'Phoebe Home Care',
    patient_text: ' for Jane',
    phoebe_intro: 'this is Phoebe with Phoebe Home Care',
    previous_visits: 'You have worked with this client before.',
    role_required: 'HHA',
    schedule_summary: 'Mondays and Wednesdays, 9:00 AM to 5:00 PM',
    shift_count: '2',
    shift_count_number: '2',
    shift_date: 'tomorrow, Wednesday, July 1st',
    shift_day_of_week: 'Wednesday',
    shift_duration: '8 hours',
    shift_frequency: 'every 2 weeks',
    shift_groups: 'Group 1:\n- Wednesday, July 1st from 9:00 AM to 5:00 PM',
    shift_list:
        '- Wednesday, July 1st from 9:00 AM to 5:00 PM with Jane in Brooklyn\n' +
        '- Thursday, July 2nd from 10:00 AM to 4:00 PM with Bob in Queens',
    shift_start_time: '9:00 AM',
    shift_end_time: '5:00 PM',
    start_date: 'tomorrow, Wednesday, July 1st',
    stats_month: 'June',
    time_and_attendance_pin: '1234',
};

export const DEFAULT_TEMPLATE_VARIABLE_PREVIEW_VALUES =
    withTemplateVariableAliases(DEFAULT_TEMPLATE_VARIABLE_SAMPLE_VALUES);

export function getTemplateVariablePreviewValuesForOrganization(
    organization:
        | {
              readonly general_settings?: {
                  readonly primary_data_source?: string | null;
              } | null;
          }
        | undefined,
): Readonly<Record<string, string>> {
    const primaryDataSource =
        organization?.general_settings?.primary_data_source;
    let ehrDisplayName = 'your EHR';
    if (
        primaryDataSource === 'wellsky' ||
        primaryDataSource === 'axiscare' ||
        primaryDataSource === 'generations_homecare' ||
        primaryDataSource === 'hhaexchange'
    ) {
        ehrDisplayName = getDataSourceDisplayName(primaryDataSource);
    }

    return withTemplateVariableAliases({
        ...DEFAULT_TEMPLATE_VARIABLE_SAMPLE_VALUES,
        ehr: ehrDisplayName,
    });
}

export function normalizeTemplateVariableToken(rawToken: string): string {
    return rawToken.replace(/[{}]/g, '');
}

export function getTemplateVariablePreviewValues(
    tokens: ReadonlyArray<string>,
    overrides: Readonly<Record<string, string>> = {},
): Record<string, string> {
    const availableValues = withTemplateVariableAliases({
        ...DEFAULT_TEMPLATE_VARIABLE_SAMPLE_VALUES,
        ...overrides,
    });
    const previewValues: Record<string, string> = {};
    for (const rawToken of tokens) {
        const token = normalizeTemplateVariableToken(rawToken);
        const value = availableValues[token];
        if (value !== undefined) {
            previewValues[token] = value;
        }
    }
    return previewValues;
}
